<template>
  <div>
     <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>


        <vs-dropdown-menu style="min-width: 100px;">
          <vs-dropdown-item @click="editProcess()" v-if="params.context.componentParent.checkEditPermission">Edit</vs-dropdown-item>
          <vs-dropdown-item @click="deleteProcess()" v-if="params.context.componentParent.checkDeletePermission">Delete</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
  
  </div>
</template>
<script>
export default {
  mounted () {
    // console.log(this.params)
  },
  methods: {
    editProcess () {
      this.params.context.componentParent.editInventory(this.params.data)
    },
    deleteProcess () {
      this.params.context.componentParent.deleteInventory(this.params.data.assets_id, this.params.rowIndex)
    }
  }

}
</script>